export default __webpack_public_path__ + "./fonts/NewChatIcon.fbaefbc2.svg";